import {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectGalleryData} from '~/GalleryPB/reducers/galleryData/selectors';
import {blocklist} from '~/GalleryPB/Template/components/QuickView/constants';
import type {Template} from '~/GalleryPB/Template/components/QuickView/types';
import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';

export const useTemplateHelpers = () => {
  const {templates} = useSelector(selectGalleryData);
  const isMediumAndUp = useIsMediumAndUp();

  const allTemplates = useMemo(
    () => [...templates.free, ...templates.premium],
    [templates.free, templates.premium]
  );

  const findTemplateById = useCallback(
    (templateId: string) => {
      if (!templateId) return undefined;
      return allTemplates.find((t) => t?.templateId === templateId);
    },
    [allTemplates]
  );

  const checkIfQuickViewEnabledForTemplate = useCallback((template: Template) => {
    if (!template?.categories) return false;
    return !blocklist.some((cat) => template.categories.includes(cat));
  }, []);

  const checkIfQuickViewEnabled = useCallback(
    (template: Template | string) => {
      if (!isMediumAndUp) return false;

      const templateObj = typeof template === 'string' ? findTemplateById(template) : template;

      return checkIfQuickViewEnabledForTemplate(templateObj);
    },
    [isMediumAndUp, findTemplateById, checkIfQuickViewEnabledForTemplate]
  );

  return {
    checkIfQuickViewEnabled,
    findTemplateById,
  };
};
